export const permissionsKeys = {
  page: 'param.positions',
  pageBlockFind: 'param.position.find',
  pageBlockCreate: 'position.create',
  pageBlockUpdate: 'position.update',
  pageBlockRemove: 'position.remove',
};
